"use client";

import { Button } from "@npm_leadtech/qr-ui-components";
import { TbAlertCircle } from "react-icons/tb";

export interface ErrorFallbackProps {
  onReset: () => void;
  title?: string;
  message?: string;
  primaryButtonLabel?: string;
  secondaryButtonLabel?: string;
}

// This UI will be replaced by the new error page design in the future

export const ErrorFallback = ({
  onReset,
  title = "Something went wrong",
  message = "There was an unexpected error. Please try again.",
  primaryButtonLabel = "Try again",
  secondaryButtonLabel = "Take me home",
}: ErrorFallbackProps) => {
  return (
    <div
      style={{
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        justifyContent: "center",
        minHeight: "60vh",
        padding: "20px",
      }}
    >
      <div
        style={{
          backgroundColor: "white",
          padding: "40px",
          borderRadius: "12px",
          boxShadow: "0 4px 12px rgba(0, 0, 0, 0.1)",
          textAlign: "center",
          maxWidth: "450px",
        }}
      >
        <div
          style={{
            width: "56px",
            height: "56px",
            backgroundColor: "#FEE2E2",
            borderRadius: "50%",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            margin: "0 auto 20px",
          }}
        >
          <TbAlertCircle
            aria-label="alert-icon"
            size={28}
            color="#DC2626"
          />
        </div>
        <h2>{title}</h2>
        <p>{message}</p>
        <div style={{ display: "flex", gap: "12px", justifyContent: "center", flexWrap: "wrap" }}>
          <Button
            onClick={onReset}
            label={primaryButtonLabel}
            ariaLabel={primaryButtonLabel}
            dataQA="error-try-again"
          />
          <Button
            onClick={() => (window.location.href = "/")}
            label={secondaryButtonLabel}
            ariaLabel={secondaryButtonLabel}
            dataQA="error-go-home"
            shape="outlined"
          />
        </div>
      </div>
    </div>
  );
};
